// extracted by mini-css-extract-plugin
module.exports = {"base":"8px","list":"noResultsTips_list__oXt8g"};